const IconIndicator = ({ bgColor, title, borderColor }) => {
  return (
    <div
      style={{
        borderColor: borderColor,
        backgroundColor: bgColor,
        border: !borderColor && "none",
      }}
      title={title}
      className={`border w-icon-xs h-icon-xs items-center  rounded-border-radius-sm   relative z-z-index-base global-hover-white`}
    ></div>
  );
};

export default IconIndicator;
